const initialState = {
  cards: [
    {
      id: 'cc-1',
      type: 'credit',
      provider: 'visa',
      nickname: 'My Visa Credit',
      mask: '4434',
      balance: 243.58,
      creditLimit: 10000
    },
    {
      id: 'cc-2',
      type: 'credit',
      provider: 'mastercard',
      nickname: 'My Rewards Card',
      mask: '2323',
      balance: 2138.3,
      creditLimit: 5000,
      frozen: true
    },
    {
      id: 'cc-3',
      type: 'credit',
      provider: 'visa',
      nickname: 'Apple Card',
      mask: '6789',
      creditLimit: 6500,
      balance: 564.12
    },
    {
      id: 'dc-1',
      type: 'debit',
      provider: 'mastercard',
      nickname: 'My MC Debit',
      mask: '2222'
    }
  ]
}

const cards = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT': {
      return { ...initialState }
    }
    case 'MODIFY_CARD': {
      const id = action.payload.id
      let index = state.cards.findIndex(c => c.id === id)
      let card = state.cards[index]

      if (!card) {
        return state
      }

      if (card) {
        card = { ...card, ...action.payload.data }
      }
      let newCards = [...state.cards]
      newCards[index] = card

      return { ...state, cards: newCards }
    }
    default: {
      return state
    }
  }
}

export default cards
